export default class AdminConsultations {
  axiosIns = null
  jwtConfig = null

  constructor(axiosIns, jwtConfig) {
    this.axiosIns = axiosIns;
    this.jwtConfig = jwtConfig;
  }

  list(params) {
    return this.axiosIns.get(`${this.jwtConfig.main.adminConsultationRoute}`, {
      params
    })
  }

  fetch(id) {
    return this.axiosIns.get(`${this.jwtConfig.main.adminConsultationRoute}/${id}`, {})
  }

  sendLabReportFiles(id) {
    return this.axiosIns.post(`${this.jwtConfig.main.adminConsultationRoute}/${id}/send-attachment`, {})
  }

  update(id, payload = {}) {
    return this.axiosIns.put(`${this.jwtConfig.main.adminConsultationRoute}/${id}`, payload, {})
  }

  markAsReceived(id) {
    return this.axiosIns.put(`${this.jwtConfig.main.adminConsultationRoute}/${id}/mark-as-received`, {})
  }

  markAsProcessing(id) {
    return this.axiosIns.put(`${this.jwtConfig.main.adminConsultationRoute}/${id}/process`, {})
  }

  upload(id, payload = {}) {
    return this.axiosIns.put(`${this.jwtConfig.main.adminConsultationRoute}/${id}/upload-attachment`, payload, {
      headers: {
        "Content-Type": "multipart/form-data"
      }
    })
  }

  attachNote(id, payload = {}) {
    return this.axiosIns.put(`${this.jwtConfig.main.adminConsultationRoute}/${id}/attach-note`, payload, {})
  }

  delete(id) {
    return this.axiosIns.delete(`${this.jwtConfig.main.adminConsultationRoute}/${id}`, {})
  }
}
